import { CellRenderType } from '/@/modules/core/table/constants/TableConstant';
import BaseCellRender from './BaseCellRender';

class ActionCellRender extends BaseCellRender {
  constructor() {
    super(CellRenderType.ACTIONS);
  }
}

export default ActionCellRender;
